/**
 * Page title utilities
 */

import { getRaceConfig } from './urlParams';

/**
 * Updates the page title and header with race information
 */
export function updatePageTitle(): void {
    const raceConfig = getRaceConfig();

    // Update document title
    document.title = `UltraSwim 33.3 - ${raceConfig.name} Ranking Progression`;

    // Update main header
    const headerTitle = document.querySelector('header h1');
    if (headerTitle) {
        headerTitle.textContent = `${raceConfig.name} Ranking Progression`;
    }

    // Update welcome dialog header
    const welcomeTitle = document.querySelector('.welcome-header h3');
    if (welcomeTitle) {
        welcomeTitle.textContent = `Welcome to UltraSwim 33.3 ${raceConfig.name}`;
    }
}
